// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Toaster-module-toast-2yAse{max-width:80%;gap:8px;gap:var(--des-dimension-gap-and-padding-general-near-medium, 8px);color:var(--des-color-fill-glyph-primary);padding:var(--des-dimension-gap-and-padding-banner-padding)}.Toaster-module-toast-2yAse.Toaster-module-error-3lcPt{color:var(--des-color-fill-glyph-on-top-of-danger-panel);background-color:var(--des-color-fill-panel-danger)}.Toaster-module-toast-2yAse.Toaster-module-success-rHG_0{color:var(--des-color-fill-glyph-on-top-of-success-panel);background-color:var(--des-color-fill-panel-success)}.Toaster-module-icon-3bF6J{width:var(--des-dimension-height-and-width-icon-x-large);height:var(--des-dimension-height-and-width-icon-x-large);flex-shrink:0}", ""]);
// Exports
exports.locals = {
	"toast": "Toaster-module-toast-2yAse",
	"error": "Toaster-module-error-3lcPt",
	"success": "Toaster-module-success-rHG_0",
	"icon": "Toaster-module-icon-3bF6J"
};
module.exports = exports;
